(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scf-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.scfArticleLightboxReady) return;
    window.scfArticleLightboxReady = true;

    let state = null;

    function show(index) {
      const { dialog, links } = state;
      state.index = (index + links.length) % links.length;
      const link = links[state.index];
      const thumb = link.querySelector('img');
      const image = document.createElement('img');
      image.className = 'scf-lightbox__image';
      image.src = link.href;
      image.alt = thumb ? thumb.alt : '';
      dialog.querySelector('[data-scf-lightbox-stage]').replaceChildren(image);
      dialog.querySelector('[data-scf-lightbox-counter]').textContent = state.index + 1 + ' / ' + links.length;
    }

    document.addEventListener('click', function (event) {
      const trigger = event.target.closest('[data-scf-lightbox-trigger]');
      if (trigger) {
        const gallery = trigger.closest('.scf-article__gallery');
        const dialog = gallery && gallery.querySelector('[data-scf-lightbox]');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        const links = Array.from(gallery.querySelectorAll('[data-scf-lightbox-trigger]'));
        state = { dialog, links, index: 0 };
        dialog.classList.toggle('scf-lightbox--single', links.length < 2);
        show(links.indexOf(trigger));
        dialog.showModal();
        return;
      }

      if (!state || !state.dialog.open) return;
      if (event.target.closest('[data-scf-lightbox-close]') || event.target === state.dialog) {
        state.dialog.close();
      } else if (event.target.closest('[data-scf-lightbox-prev]')) {
        show(state.index - 1);
      } else if (event.target.closest('[data-scf-lightbox-next]')) {
        show(state.index + 1);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!state || !state.dialog.open || state.links.length < 2) return;
      if (event.key === 'ArrowLeft') show(state.index - 1);
      if (event.key === 'ArrowRight') show(state.index + 1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scf-dermatologist-directory"] && !Shopify.designMode) return;
  try {
    
  function initScfDermDirectory(root) {
    if (!root || root.dataset.scfDermReady === 'true') return;
    root.dataset.scfDermReady = 'true';

    const searchInput = root.querySelector('[data-scf-derm-search]');
    const filterGroup = root.querySelector('[data-scf-derm-filters]');
    const items = Array.from(root.querySelectorAll('[data-scf-derm-item]'));
    const countNum = root.querySelector('[data-scf-derm-count-num]');
    const emptyEl = root.querySelector('[data-scf-derm-empty]');
    let activeProvince = '';

    function applyFilters() {
      const query = (searchInput && searchInput.value ? searchInput.value : '').trim().toLowerCase();
      let visible = 0;

      items.forEach((item) => {
        const searchText = item.getAttribute('data-search') || '';
        const provinces = (item.getAttribute('data-provinces') || '').split('|').filter(Boolean);
        const matchesSearch = !query || searchText.includes(query);
        const matchesProvince = !activeProvince || provinces.includes(activeProvince);
        const show = matchesSearch && matchesProvince;
        item.hidden = !show;
        if (show) visible += 1;
      });

      if (countNum) countNum.textContent = String(visible);
      if (emptyEl) emptyEl.hidden = visible > 0;
    }

    if (searchInput) {
      searchInput.addEventListener('input', applyFilters);
    }

    if (filterGroup) {
      filterGroup.addEventListener('click', (event) => {
        const chip = event.target.closest('[data-scf-derm-province]');
        if (!chip || !filterGroup.contains(chip)) return;

        activeProvince = chip.getAttribute('data-scf-derm-province') || '';
        filterGroup.querySelectorAll('[data-scf-derm-province]').forEach((btn) => {
          const isActive = btn === chip;
          btn.classList.toggle('scf-derm__chip--active', isActive);
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        applyFilters();
      });
    }

    applyFilters();
  }

  function initAllScfDermDirectories() {
    document.querySelectorAll('[data-scf-derm-directory]').forEach(initScfDermDirectory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllScfDermDirectories, { once: true });
  } else {
    initAllScfDermDirectories();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector
      ? event.target.querySelector('[data-scf-derm-directory]')
      : null;
    if (root) {
      root.dataset.scfDermReady = 'false';
      initScfDermDirectory(root);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
